/**
 * Export `Place` type.
 */

export type Place = {
  slug: string;
};

/**
 * Export `places` config.
 */

export const places: Place[] = [
  {
    slug: 'alcoutim'
  },
  {
    slug: 'beja'
  },
  {
    slug: 'braganca'
  },
  {
    slug: 'coimbra'
  },
  {
    slug: 'evora-montemor-o-novo'
  },
  {
    slug: 'guarda-pinhel-cidadelhe'
  },
  {
    slug: 'guimaraes-citania-briteiros'
  },
  {
    slug: 'lagos'
  },
  {
    slug: 'lisboa-sintra-cascais'
  },
  {
    slug: 'mafra'
  },
  {
    slug: 'setubal'
  },
  {
    slug: 'tomar-constancia'
  },
  {
    slug: 'vila-real'
  }
];
